import React from "react";
import { NavLink, Link } from "react-router-dom";
import Button from "../components/buttons/Button";
import useMedia from "../hooks/useMedia";
import useScroll from "../hooks/useScroll";
import AuthContext from "../contexts/auth";
import Avatar from "../components/avatar/Avatar";
import MenuMobile from "./MenuMobile";
import Menu from "../components/menu/Menu";
import LogoSVG from "../images/logos/EBD_logo.svg";
import MenuSVG from "../images/icons/menu.svg";

const Navbar = () => {
  const autCtx = React.useContext(AuthContext);
  const media = useMedia();
  if (media === "mobile") return <NavbarMobile {...autCtx} />;
  return <NavbarDesktop {...autCtx} />;
};

const NavbarDesktop = ({ user, logout }) => {
  const currentPath = window.location.pathname;

  let itemMenuAdd = null;
  if (user?.role === "designer")
    itemMenuAdd = { label: "Add a project", to: `/designer/editwork` };
  else if (user?.role === "contractor")
    itemMenuAdd = { label: "Add a job", to: `/project/editmission` };

  return (
    <nav className="oNavbar">
      <div className="oNavbar_wrapper -contained">
        <Link to="/">
          <img src={LogoSVG} alt="Logo" className="oNavbar_logo" />
        </Link>
        <div className="oNavbar_links">
          <NavLink to="/jobs" className="oNavbar_link">
            <h5>Jobs</h5>
          </NavLink>
          <NavLink to="/designers" className="oNavbar_link">
            <h5>Designers</h5>
          </NavLink>
          <NavLink to="/showcase" className="oNavbar_link">
            <h5>Showcase</h5>
          </NavLink>
          <NavLink to="/tools" className="oNavbar_link">
            <h5>Tools</h5>
          </NavLink>
          <NavLink to="/about-us" className="oNavbar_link">
            <h5>About</h5>
          </NavLink>
          <div className="oNavbar_separator" />
          {user ? (
            <Menu
              items={[
                { label: "Profile", to: `/${user.role}/${user.slug}` },
                { label: "Edit my profile", to: `/settings` },
                itemMenuAdd,
                { label: "Sign out", onClick: logout },
              ].filter(Boolean)}
            >
              <Avatar avatar={user.avatar} small />
            </Menu>
          ) : (
            <>
              <NavLink
                to={"/login?redirect_url=" + currentPath}
                className="oNavbar_link -signIgn"
              >
                <h5>Log in</h5>
              </NavLink>
              <NavLink to="/signup" className="oNavbar_signUp">
                <Button arrowRight rounded>
                  Sign up
                </Button>
              </NavLink>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

const NavbarMobile = props => {
  const [isOpen, setOpen] = React.useState(false);
  const { blockScroll, freeScroll } = useScroll();

  React.useEffect(() => {
    if (isOpen) blockScroll();
    else freeScroll();
  }, [isOpen]); // eslint-disable-line
  return (
    <nav className="oNavbarMobile">
      <Link to="/">
        <img src={LogoSVG} alt="Logo" className="oNavbar_logo" />
      </Link>
      <div className="oNavbarMobile_trigger" onClick={() => setOpen(!isOpen)}>
        <img src={MenuSVG} alt="Menu" className="oNavbar_menu" />
      </div>
      {isOpen && <MenuMobile {...props} />}
    </nav>
  );
};

export default Navbar;
